import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import AutoBind from 'react-autobind';

import {
    Cliente_Fiscal_Liskey, ClienteFiscal_Insert, ClienteFiscal_Update, SAT_UsoCFDI_Lista, Pais_Lista,
    Nivel1_Lista, Nivel2_Lista, Nivel3_Lista, DebeOcultarCamposRFC, Cliente_Fiscal_Lista_PorNombre, SAT_RegimenFiscal_Lista, SAT_RegimenFiscal_Lista2, Nivel3_ListaCodPostalAsociado,
    SAT_RegimenFiscal_ListaALL, SAT_UsoCFDI
} from '../../request/rfc';

import { Option } from './children/select-option';
import { debug } from 'util';

const objPais = { Pais_Id: 0, Nombre: 'Seleccione País >>' };
const objNivel1 = { Nivel1_id: 0, Nombre: 'Seleccione Estado >>' };
const objNivel2 = { Nivel2_id: 0, Nombre: 'Seleccione Municipio >>' };
const objNivel3 = { Nivel3_id: 0, Nombre: 'Seleccione Colonia >>' };
const objNivel3Cod = { Nivel3_id: 0, Nivel2_id: 0, Nivel1_id: 0 };
const objClientes = [];
var Nivel1_Cod = 0;

//const DefaultOptionUsoCFDI = { Uso_Clave: "", Uso_Descripcion: 'Seleccionar Autorizador' }
//const DefaultOptionRegimen = { Uso_Clave: "", Uso_Descripcion: 'Seleccionar Autorizador' }

export default class RFC extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            cliente: {
                nombre: '',
                rfc: '',
                codigopostal: '',
                usocfdi: 0,
                email: '',
                calle: '',
                numeroexterior: '',
                telefono: '',
                pais: 1,
                estado: 1,
                municipio: 1,
                colonia: 1,
                numerointerior: '',
                celular: '',
                direccion: '',
                clienteBusqueda: '',
                clienteId: '',
                RegimenFiscal: ''
                
            },
            usoCFDILista: [],
            RegimenFiscalLista: [],
            paisLista: [objPais],
            nivel1Lista: [objNivel1],
            nivel2Lista: [objNivel2],
            nivel3Lista: [objNivel3],
            Nivel3Cod: [objNivel3Cod],
            hasChanges: false,
            existeRFC: false,
            showFormDetail: true,
            ocultarCamposRFC: false,
            clienteNombre: ''

        };
        AutoBind(this);
    }

    componentDidMount() {
        DebeOcultarCamposRFC()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ ocultarCamposRFC: Data === 1 });
                }
            })
            .catch((err) => { console.log(err); });

        this.cargarUsoCFDI();
        //this.cargarRegimenFiscal('');
        this.SAT_RegimenFiscal_ListaALL();
        this.cargarPais();
        this.cargarEstado();
        this.cargarMunicipios(-1);
        this.cargarColonias(-1, -1);
        this.initTable([]);
        const $table = $(this.refs.tblClientes);
        $table.on('click-row.bs.table', this.onClickTable);

    }

    CargarClienteFiscal() {

        const { hasChanges, existeRFC, usoCFDILista, clienteNombre } = this.state;
        const { tipoFactura } = this.props.match.params;
        const { isSiteInterno } = this.props;
        const datos = this.getJsonData();
        const claveCFDI = usoCFDILista.filter(item => item.Uso_Id == datos.Uso_Id)[0];

        if (!claveCFDI) {
            alert('no existe la clave del cfdi');
            return;
        }

        let url = '';
        if (isSiteInterno == '1') {
            if (tipoFactura == '0') {
                url = `${this.state.baseUrl}${Routes.Ticket}/${datos.ClienteFiscal_Id}/${datos.Email}/${claveCFDI.Uso_Clave}/${tipoFactura}`
            } else {
                url = `${this.state.baseUrl}${Routes.TicketCredito}/${datos.ClienteFiscal_Id}/${datos.Email}/${claveCFDI.Uso_Clave}/${tipoFactura}/${datos.Cliente_Id}/${clienteNombre}`
            }

        } else {
            url = `${this.state.baseUrl}${Routes.Transaccion}/${datos.ClienteFiscal_Id}/${datos.Email}/${claveCFDI.Uso_Clave}`;
        }

        if (existeRFC) {
            if (hasChanges) { // update si tiene cambios, de lo contrario no ejecuta nada
                ClienteFiscal_Update(datos)
                    .then(({ data: Response }) => {
                        if (Response.Message !== '') {
                            alert(Response.Message);
                        } else { this.props.history.replace(url); }
                    })
                    .catch((err) => { console.log(err); });
            } else { this.props.history.replace(url); }
        } else { // insert
            ClienteFiscal_Insert(datos)
                .then(({ data: Response }) => {
                    if (Response.Message !== '') {
                        alert(Response.Message);
                    } else { this.props.history.replace(url); }
                })
                .catch((err) => { console.log(err); });
        }

    }

    onSubmit(e) {

        e.preventDefault();

        this.CargarClienteFiscal();

    }

    getJsonData() {
        const { cliente } = this.state;
        return {
            ClienteFiscal_Id: cliente.rfc,
            Nombre: cliente.nombre,
            Email: cliente.email,
            ApartadoPostal: cliente.codigopostal,
            Nivel1_Id: cliente.estado,
            Nivel2_Id: cliente.municipio,
            Nivel3_Id: cliente.colonia,
            Calle: cliente.calle,
            Numero_Interior: cliente.numerointerior,
            Numero_Exterior: cliente.numeroexterior,
            Pais_Id: cliente.pais,
            Uso_Id: cliente.usocfdi,
            Celular: cliente.celular,
            Telefono: cliente.telefono,
            Direccion: cliente.direccion,
            Cliente_Id: cliente.clienteId == '' ? 0 : cliente.clienteId,
            RegimenFiscal: cliente.RegimenFiscal
        };
    }

    setValuesInJSON(data) {
        return {
            codigopostal: data.ApartadoPostal,
            email: data.Email,
            usocfdi: data.Uso_Id,
            rfc: data.ClienteFiscal_Id,
            nombre: data.Nombre,
            direccion: data.Direccion,
            estado: data.Nivel1_Id,
            municipio: data.Nivel2_Id,
            colonia: data.Nivel3_Id,
            calle: data.Calle,
            numerointerior: data.Numero_Interior,
            numeroexterior: data.Numero_Exterior,
            pais: data.Pais_Id,
            celular: data.Celular,
            telefono: data.Telefono,
            clienteId: data.Cliente_Id,
            RegimenFiscal: data.RegimenFiscal
        }
    }

    onSearch() {
        const { cliente } = this.state;
        if (cliente.rfc === '') {
            alert('debe ingresar un valor para poder buscar');
            return;
        }

        const { tipoFactura } = this.props.match.params;

        if (typeof tipoFactura == typeof undefined) {

            Cliente_Fiscal_Liskey({ pClienteFiscal: cliente.rfc, pClienteId: '-1' })
                .then(({ data: Response }) => {
                    if (Response.Data != null) {
                        // cargar los valores para municipio y colonia
                        this.cargarMunicipios(Response.Data.Nivel1_Id);
                        this.cargarColonias(Response.Data.Nivel1_Id, Response.Data.Nivel2_Id);
                       
                        this.cargarUsoCFDI();
                        console.log('lista usoo', this.state.usoCFDILista);
                      //  this.cargarRegimenFiscal(this.state.usoCFDILista[Response.Data.Uso_Id - 1].Uso_Clave);
                        this.setState({
                            cliente: Object.assign({}, cliente, this.setValuesInJSON(Response.Data)),
                            existeRFC: Response.Data.ClienteFiscal_Id != '' ? true : false
                        });
                      //  this.cargarRegimenFiscald(Response.Data.RegimenFiscal)
                        console.log('lista usoo', this.state.RegimenFiscalLista);
                    } else {
                        this.setState({ showFormDetail: false });
                    }
                })
                .catch((err) => { console.log(err); });

        } else {

            if (tipoFactura == '0') {

                Cliente_Fiscal_Liskey({ pClienteFiscal: cliente.rfc, pClienteId: '-1' })
                    .then(({ data: Response }) => {
                        if (Response.Data != null) {
                            // cargar los valores para municipio y colonia
                            this.cargarMunicipios(Response.Data.Nivel1_Id);
                            this.cargarColonias(Response.Data.Nivel1_Id, Response.Data.Nivel2_Id);
                            this.cargarUsoCFDI();
                            console.log('lista uso', this.state.usoCFDILista);
                           // this.cargarRegimenFiscal(this.state.usoCFDILista[Response.Data.Uso_Id - 1].Uso_Clave);
                            this.setState({
                                cliente: Object.assign({}, cliente, this.setValuesInJSON(Response.Data)),
                                existeRFC: Response.Data.ClienteFiscal_Id != '' ? true : false
                            });

                            if (Response.Data.RegimenFiscal == "") {
                                console.log('hoola');
                                this.SAT_RegimenFiscal_ListaALL()
                            } else {
                                console.log('bu');
                                this.cargarRegimenFiscal2(Response.Data.RegimenFiscal)
                            }
                            
                        } else {
                            this.setState({ showFormDetail: false });
                        }
                    })
                    .catch((err) => { console.log(err); });

            } else {

                Cliente_Fiscal_Liskey({ pClienteFiscal: cliente.rfc, pClienteId: cliente.clienteId })
                    .then(({ data: Response }) => {
                        if (Response.Data != null) {
                            // cargar los valores para municipio y colonia
                            this.cargarMunicipios(Response.Data.Nivel1_Id);
                            this.cargarColonias(Response.Data.Nivel1_Id, Response.Data.Nivel2_Id);
                            this.cargarUsoCFDI();
                            console.log('lista uso', this.state.usoCFDILista);
                           // this.cargarRegimenFiscal(this.state.usoCFDILista[Response.Data.Uso_Id - 1].Uso_Clave);
                            this.setState({
                                cliente: Object.assign({}, cliente, this.setValuesInJSON(Response.Data)),
                                existeRFC: Response.Data.ClienteFiscal_Id != '' ? true : false
                            });
                            //this.cargarRegimenFiscal2(Response.Data.RegimenFiscal)
                            if (Response.Data.RegimenFiscal == "") {
                                console.log('hoola');
                                this.SAT_RegimenFiscal_ListaALL()
                            } else {
                                console.log('bu');
                                this.cargarRegimenFiscal2(Response.Data.RegimenFiscal)
                            }
                        } else {
                            this.setState({ showFormDetail: false });
                        }
                    })
                    .catch((err) => { console.log(err); });

            }

        }





    }

    onSearchCliente() {

        const { cliente } = this.state;
        if (cliente.clienteBusqueda === '') {
            alert('Debe ingresar un valor para poder buscar');
            return;
        }
        Cliente_Fiscal_Lista_PorNombre(cliente.clienteBusqueda)
            .then(({ data: Response }) => {
                if (Response.Data != null) {
                    const { Message, Data } = Response;
                    const data = Data.map(item => Object.assign({}, item, {}));
                    this.loadTable(data);
                    $(this.refs.modal).modal('show');

                } else {
                    alert('No se encontraron datos');
                }
            })
            .catch((err) => { console.log(err); });



    }

    loadTable(data) {
        const $table = $(this.refs.tblClientes);
        $table.bootstrapTable('load', data || []);
    }

    initTable(data) {

        const $table = $(this.refs.tblClientes);

        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 300,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) { return { 'data-id': row.ClienteFiscal_Id }; },
            columns: [{
                title: 'Cliente Id',
                field: 'Cliente_Id'
            }, {
                title: 'Nombre',
                field: 'ClienteNombre'
            }, {
                title: 'Cliente Fiscal ID',
                field: 'ClienteFiscal_Id',
                sortable: true

            }]
        });
    }

    onClickTable(row, $element, field) {
        const selectedRow = document.querySelector('tr.table-info');
        if (!!selectedRow)
            selectedRow.classList.remove('table-info');
        document.querySelector(`tr[data-id="${$element.ClienteFiscal_Id}"]`).classList.add('table-info');
        // this.setState({ selectedRow: $element });
        this.setState({
            cliente: {
                rfc: $element.ClienteFiscal_Id,
                clienteId: $element.Cliente_Id

            },
            clienteNombre: $element.ClienteNombre

        });
    }
     
    onChange(e) {
        const { name, value } = e.target;
        this.setState({
            cliente: Object.assign({}, this.state.cliente, { [name]: value }),
            hasChanges: name === 'rfc' ? false : true // no valida el cambio si es RFC ya que tiene que digitarlo para buscar
        });

       
        if (name === 'codigopostal')
        {
            this.cargarColoniasCodigoPostal(value)
        }
       
        console.log(name, value)

    }
    onChangeRegimen(e) {


        SAT_UsoCFDI_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {               
                    this.setState({ usoCFDILista: Data.map(item => Object.assign({}, item, { Uso_Descripcion: `${item.Uso_Descripcion} - ${item.Uso_Clave}` })) });
                }
            })
            .catch((err) => { console.log(err); });


        const { name, value } = e.target;

        this.setState({
            cliente: Object.assign({}, this.state.cliente, { [name]: value })           
        });

        this.usocfdi_by_RFC(value);
       
    }
    usocfdi_by_RFC(pRegimen) {
        SAT_UsoCFDI(pRegimen)
            .then(({ data: Response }) => {
                const { Message, Data } = Response;

                if (Message !== '') {
                    alert(Message);
                } else {
                    
                    this.setState({
                        cliente: Object.assign({}, this.state.cliente, { usocfdi: Data })
                    });
                }
            })
            .catch((err) => { console.log(err); });

    }
    onChangeCfdi(e) {

        const { name, value } = e.target;

        this.setState({
            cliente: Object.assign({}, this.state.cliente, { [name]: value })
        });
        //switch (name) {
        //    case "usocfdi":
        //        this.setState({ ...this.state.cliente, usocfdi: value })
        //        const clave = e.target.options[e.target.selectedIndex].text.split('-')[1].trim();
        //        this.cargarRegimenFiscal(clave);

        //    case "":
        //}
    }
    onChangeSelects(e) {
        const { name, value } = e.target;
        switch (name) {
            case 'estado':
                this.cargarMunicipios(value);
                this.setState({
                    cliente: Object.assign({}, this.state.cliente, { [name]: value, municipio: 0, colonia: 0 }),
                    hasChanges: true,
                    nivel2Lista: [objNivel2],
                    nivel3Lista: [objNivel3]
                });
                break;
            case 'municipio':
                this.cargarColonias(this.state.cliente.estado, value);
                this.setState({
                    cliente: Object.assign({}, this.state.cliente, { [name]: value, colonia: 0 }),
                    hasChanges: true,
                    nivel3Lista: [objNivel3]
                });
                break;
        }
    }

    onClean() {
        this.setState({
            cliente: {
                nombre: '',
                rfc: '',
                codigopostal: '',
                usocfdi: '0',
                email: '',
                calle: '',
                numeroexterior: '',
                telefono: '',
                pais: 1,
                estado: '',
                municipio: '',
                colonia: '',
                numerointerior: '',
                celular: '',
                nivel1: 0,
                nivel2: 0,
                nivel3: 0,
                direccion: ''
            },
            nivel2Lista: [objNivel2],
            nivel3Lista: [objNivel3]
        });
    }

    showFormDetails() {
        this.setState((prevState) => ({ showFormDetail: !prevState.showFormDetail }));
    }

    cargarUsoCFDI() {
    
        SAT_UsoCFDI_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ usoCFDILista: Data.map(item => Object.assign({}, item, { Uso_Descripcion: `${item.Uso_Descripcion} - ${item.Uso_Clave}` }))  });
                }
            })
            .catch((err) => { console.log(err); });
    }

    SAT_RegimenFiscal_ListaALL() {

        SAT_RegimenFiscal_ListaALL()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ RegimenFiscalLista: Data.map(item => Object.assign({}, item, { Regimen_Descripcion: `${item.Regimen_Descripcion} - ${item.Regimen_Clave}` })) });
                }
            })
            .catch((err) => { console.log(err); });
    }
    cargarRegimenFiscal(pclave) {
        SAT_RegimenFiscal_Lista(pclave)
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ RegimenFiscalLista: Data.map(item => Object.assign({}, item, { Regimen_Descripcion: `${item.Regimen_Descripcion} - ${item.Regimen_Clave}` })) });
                }
            })
            .catch((err) => { console.log(err); });
    }
    cargarRegimenFiscal2(pclave) {
        SAT_RegimenFiscal_Lista2(pclave)
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ RegimenFiscalLista: Data.map(item => Object.assign({}, item, { Regimen_Descripcion: `${item.Regimen_Descripcion} - ${item.Regimen_Clave}` })) });
                }
            })
            .catch((err) => { console.log(err); });
    }
    
    cargarPais() {
        Pais_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ paisLista: Data });
                }
            })
            .catch((err) => { console.log(err); });
    }

    cargarEstado() {
        Nivel1_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ nivel1Lista: [{ Nivel1_id: 0, Nombre: 'Seleccione Estado >>' }, ...Data] });
                }
            })
            .catch((err) => { console.log(err); });
    }

    cargarMunicipios(estado) {
        Nivel2_Lista(estado)
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ nivel2Lista: [{ Nivel2_id: 0, Nombre: 'Seleccione Municipio >>' }, ...Data] });
                }
            })
            .catch((err) => { console.log(err); });
    }

    cargarColonias(estado, municipio) {
        Nivel3_Lista(estado, municipio)
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ nivel3Lista: [{ Nivel3_id: 0, Nombre: 'Seleccione Colinia >>' }, ...Data] });
                }
            })
            .catch((err) => { console.log(err); });
    }
    cargarColoniasCodigoPostal(value) {
        Nivel3_ListaCodPostalAsociado(value)
            .then(({ data: Response }) => {
            const { Message, Data } = Response;
            if (Message !== '') {
                alert(Message);
            } else {
               
                this.setState({ Nivel3Cod: [{ Nivel1_id: 0, Nivel2_id: 0, Nivel3_id: 0 }, ...Data] });
                if (Data.length > 0)
                {
                    this.cargarMunicipios(Data[0].Nivel1_id);
                    this.cargarColonias(Data[0].Nivel1_id, Data[0].Nivel2_id)
                    this.setState({
                        cliente: Object.assign({}, this.state.cliente, { estado: Data[0].Nivel1_id, municipio: Data[0].Nivel2_id, colonia: Data[0].Nivel3_id }),
                        hasChanges: true,
                    });
                }
                
            }
            })
            .catch((err) => { console.log(err); });
    }

    onCloseModal() {
        $(this.refs.modal).modal('hide');
    }

    onSelectCliente() {
        $(this.refs.modal).modal('hide');

        this.onSearch();

    }

    render() {

        const { baseUrl, cliente, usoCFDILista, showFormDetail, paisLista, nivel1Lista, nivel2Lista, nivel3Lista, ocultarCamposRFC, showBusquedaCredito, RegimenFiscalLista } = this.state;
        const cssClass = showFormDetail ? 'd-none' : '';
        const cssClassCreditoBusqueda = this.props.match.params.tipoFactura == '0' || !this.props.match.params.tipoFactura ? 'd-none' : '';

        const optionsCFDI = usoCFDILista.map((item, index) => <Option key={index}
            value={item.Uso_Id}
            label={item.Uso_Descripcion} />);
        const optionsRegimenFiscal = RegimenFiscalLista.map((item, index) => <Option key={index}
            value={item.Regimen_Clave}
            label={item.Regimen_Descripcion} />);
        const optionsPais = paisLista.map((item, index) => <Option key={index}
            value={item.Pais_Id}
            label={item.Nombre} />);
        const optionsEstado = nivel1Lista.map((item, index) => <Option key={index}
            value={item.Nivel1_id}
            label={item.Nombre} />);
        const optionsMunicipio = nivel2Lista.map((item, index) => <Option key={index}
            value={item.Nivel2_id}
            label={item.Nombre} />);
        const optionsColonia = nivel3Lista.map((item, index) => <Option key={index}
            value={item.Nivel3_id}
            label={item.Nombre} />);

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <button type="button" className="btn btn-custom-theme float-right mr-sm-1" onClick={this.showFormDetails}>
                                    <i className="fas fa-caret-down"></i>
                                </button>
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right mr-sm-1">
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </div>
                        </div>

                        <div className="col-12">
                            <label className={`${cssClassCreditoBusqueda}`}>Cliente:</label>
                            <div className={`input-group mb-3 ${cssClassCreditoBusqueda}`}>
                                <input type="text" className="form-control" name="clienteBusqueda" value={cliente.clienteBusqueda}
                                    onChange={this.onChange}
                                    onKeyPress={(e) => { if (e.which === 13) this.onSearchCliente() }} required />
                                <div className="input-group-append">
                                    <button className="btn btn-secondary" type="button" onClick={this.onSearchCliente}>
                                        <i className="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <label>RFC:</label>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control" name="rfc" value={cliente.rfc}
                                    onChange={this.onChange}
                                    onKeyPress={(e) => { if (e.which === 13) this.onSearch() }} />
                                <div className="input-group-append">
                                    <button className="btn btn-secondary" type="button" onClick={this.onSearch}>
                                        <i className="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>


                        <hr />
                        <form id="form-rfc" onSubmit={this.onSubmit}>
                            <div className="col-12 form-group">
                                <label>Nombre:</label>
                                <input type="text" className="form-control" name="nombre" value={cliente.nombre} onChange={this.onChange} required />
                            </div>
                            <div className="col-12 form-group">
                                <label>Correo Electrónico:</label>
                                <input type="text" className="form-control" name="email" value={cliente.email} onChange={this.onChange} required />
                            </div>
                            <div className="col-12 form-group">
                                <label>Código Postal:</label>
                                <input type="text" className="form-control" name="codigopostal" value={cliente.codigopostal} onChange={this.onChange} required />
                            </div>
                            <div className={`col-12 form-group ${cssClass}`}>
                                <label>Calle:</label>
                                <input type="text" className="form-control" name="calle" value={cliente.calle} onChange={this.onChange} />
                            </div>
                            <div className={`col-12 form-group ${cssClass}`}>
                                <label>Número Exterior:</label>
                                <input type="text" className="form-control" name="numeroexterior" value={cliente.numeroexterior} onChange={this.onChange} />
                            </div>
                            <div className="col-12 form-group" type="hidden">
                                <label>Regimen Fiscal:</label>
                                <select className="form-control" id="RegimenFiscal" name="RegimenFiscal" value={cliente.RegimenFiscal} onChange={this.onChangeRegimen}>
                                    <option value="">Seleccionar Regimen</option>
                                    {optionsRegimenFiscal}
                                </select>
                            </div>
                            <div className="col-12 form-group">
                                <label>Uso CFDI:</label>
                                <select className="form-control" id="usocfdi" name="usocfdi" value={cliente.usocfdi} onChange={this.onChange} required>
                                    <option value="" selected="selected">Seleccionar uso CFDI</option>
                                    {optionsCFDI}
                                </select>
                            </div>  
                            
                            <div className={`col-12 form-group ${cssClass}`}> 
                                <label>País:</label>
                                <select className="form-control" name="pais" value={cliente.pais} onChange={this.onChange} >
                                    {optionsPais}
                                </select>
                            </div>
                            <div className={`col-12 form-group ${cssClass}`}>
                                <label>Estado:</label>
                                <select className="form-control" name="estado" value={cliente.estado} onChange={this.onChangeSelects} >
                                    {optionsEstado}
                                </select>
                            </div>
                            <div className={`col-12 form-group ${cssClass}`}>
                                <label>Municipio:</label>
                                <select className="form-control" name="municipio" value={cliente.municipio} onChange={this.onChangeSelects} >
                                    {optionsMunicipio}
                                </select>
                            </div>
                            <div className={`col-12 form-group ${cssClass}`}>
                                <label>Colonia:</label>
                                <select className="form-control" name="colonia" value={cliente.colonia} onChange={this.onChange} >
                                    {optionsColonia}
                                </select>
                            </div>
                            <div className={`col-12 form-group ${cssClass}`}>
                                <label>Número Interior:</label>
                                <input type="text" className="form-control" name="numerointerior" value={cliente.numerointerior} onChange={this.onChange} />
                            </div>
                            <div className={ocultarCamposRFC ? 'd-none' : ''}>
                                <div className={`col-12 form-group ${cssClass}`}>
                                    <label>Teléfono:</label>
                                    <input type="text" className="form-control" name="telefono" value={cliente.telefono} onChange={this.onChange} />
                                </div>
                                <div className={`col-12 form-group ${cssClass}`}>
                                    <label>Celular:</label>
                                    <input type="text" className="form-control" name="celular" value={cliente.celular} onChange={this.onChange} />
                                </div>
                                <div className={`col-12 form-group ${cssClass}`}>
                                    <label>Dirección:</label>
                                    <textarea className="form-control" name="direccion" value={cliente.direccion} onChange={this.onChange} ></textarea>
                                </div>
                            </div>
                            <div className="col-12 form-group">
                                <button type="button" className="btn btn-custom-theme float-right" onClick={this.onClean}>
                                    <i className="fas fa-undo-alt"></i>
                                </button>
                                <button type="sumbit" className="btn btn-custom-theme float-right mr-sm-1">
                                    <i className="far fa-save"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="modal" tabIndex="-1" role="dialog" ref="modal" style={{ display: 'none' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Clientes</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <table ref="tblClientes"></table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-custom-theme" onClick={this.onSelectCliente}>
                                    <i className="fas fa-check"></i> Seleccionar
                            </button>

                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/rfc/index.js